import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/modules/shared.module';

import { routing } from './dealer.routing';
import { AppComponent } from '../app.component';
import { ListComponent } from './list/list.component';

import { AuthGuard } from '../auth.guard';
import { DealerService } from './services/dealer.service';
import { RouterModule } from '@angular/router';
import { DealerUsersComponent } from './dealer-users/dealer-users.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forRoot(routing, {}),
    SharedModule
  ],
  declarations: [ListComponent, DealerUsersComponent],
  exports: [],
  providers: [AppComponent, AuthGuard, DealerService]
})
export class DealerModule { }
